import { Box, Typography, TextField } from "@mui/material";
import { DirectionsCarOutlined as CarIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import { colorsFoundation } from "../../../theme/index.js";

/**
 * "Welches Fahrzeug ist betroffen?" — KFZ-only customer step. Writes
 * `fahrzeug_kennzeichen` (and marke/modell when a vehicle is picked). If the
 * contract carries a vehicle list it renders selectable cards; otherwise it
 * falls back to a plain Kennzeichen input.
 */
export default function ClaimVehicleCard({
  model = {},
  values = {},
  onChange,
  disabled = false,
}) {
  const vehicles =
    model.fahrzeuge || model.sparteObj?.fahrzeuge || model.vehicles || [];
  const selected = values.fahrzeug_kennzeichen || "";

  const setField = (name, value) =>
    onChange?.({ target: { name, value } });

  const pick = (v) => {
    if (disabled) return;
    setField("fahrzeug_kennzeichen", v.kennzeichen);
    if (v.marke) setField("fahrzeug_marke", v.marke);
    if (v.modell) setField("fahrzeug_modell", v.modell);
  };

  if (!Array.isArray(vehicles) || vehicles.length === 0) {
    return (
      <Box sx={{ width: "100%", maxWidth: 320 }}>
        <TextField
          label="Kennzeichen des betroffenen Fahrzeugs"
          value={selected}
          disabled={disabled}
          fullWidth
          size="small"
          onChange={(e) => setField("fahrzeug_kennzeichen", e.target.value)}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: "12px", flexWrap: "wrap", width: "100%" }}>
      {vehicles.map((v) => {
        const active = selected === v.kennzeichen;
        return (
          <Box
            key={v.kennzeichen}
            onClick={() => pick(v)}
            sx={{
              flex: "1 1 220px",
              display: "flex",
              alignItems: "center",
              gap: "11px",
              cursor: disabled ? "default" : "pointer",
              border: `${active ? 1.5 : 1}px solid ${
                active ? colorsFoundation.key.blue[600] : colorsFoundation.gray[200]
              }`,
              borderRadius: "12px",
              p: "15px 16px",
              backgroundColor: active ? colorsFoundation.key.blue[50] : "#fff",
            }}
          >
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "9px",
                flex: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: colorsFoundation.key.blue[50],
                color: colorsFoundation.key.blue[600],
              }}
            >
              <CarIcon sx={{ fontSize: 19 }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: colorsFoundation.gray[900],
                }}
              >
                {v.kennzeichen}
              </Typography>
              <Typography
                sx={{ fontSize: "12px", color: colorsFoundation.gray[500] }}
              >
                {[v.marke, v.modell].filter(Boolean).join(" · ")}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

ClaimVehicleCard.propTypes = {
  model: PropTypes.object,
  values: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
